import ButtonMenu from "../ButtonMenu";
import MenuItem from "@material-ui/core/MenuItem";
import React, { Component } from "react";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { Trans } from "react-i18next";
import TextSection from "../template/TextSection";
import Dialog from "@material-ui/core/Dialog";
import AddSection from "./AddSection.js";
import { connect } from "react-redux";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import DisplayDecisionTree from "../tree/DisplayDecisionTree";

export class TemplateSection extends Component {
  render() {
    let title = {};
    let content = {};
    let styling = {};
    if (this.props.styling) {
      styling = this.props.styling;
    }
    if (this.state.css && this.state.css.title && this.state.css.title.bold) {
      title.fontWeight = "bold";
    }
    if (this.state.css && this.state.css.title && this.state.css.title.italic) {
      title.fontStyle = "italic";
    }
    if (
      this.state.css &&
      this.state.css.title &&
      this.state.css.title.underline
    ) {
      title.textDecoration = "underline";
    }
    if (
      this.state.css &&
      this.state.css.title &&
      this.state.css.title.fontSize
    ) {
      title.fontSize = this.state.css.title.fontSize;
    }
    if (
      this.state.css &&
      this.state.css.title &&
      this.state.css.title.fontStyle &&
      this.state.css.title.fontGeneric
    ) {
      title.fontFamily =
        this.state.css.title.fontStyle + ", " + title.fontGeneric;
    }
    if (this.state.css && this.state.css.title && this.state.css.title.colour) {
      title.color = this.state.css.title.colour;
    }
    if (
      this.state.css &&
      this.state.css.content &&
      this.state.css.content.colour
    ) {
      content.color = this.state.css.content.colour;
    }
    return (
      <div
        onMouseOver={this.mouseOver}
        onMouseOut={this.mouseOver}
        style={styling}
        {...this.props}
        ref={this.props.innerRef}
        aria-label="Template section"
      >
        <CardHeader
          title={
            <Typography component="h2" style={title}>
              {this.props.section.name}
            </Typography>
          }
          disableTypography
          avatar={
            !this.state.css.visible && (
              <VisibilityOffIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
            )
          }
          action={
            <ButtonMenu title="section" ariaLabel={`section options`}>
              <MenuItem onClick={this.openEdit} aria-label="Edit section">
                <Trans i18nKey="template_section_edit_section" />
              </MenuItem>
              <MenuItem
                onClick={() => this.props.deleteSection(this.props.section)}
                aria-label="Delete section"
              >
                <Trans i18nKey="template_section_delete_section" />
              </MenuItem>
            </ButtonMenu>
          }
        />
        <CardContent>
          {this.props.section.type === "tree" ? (
            <DisplayDecisionTree
              isSection
              node={JSON.parse(this.props.section.defaultText)}
            />
          ) : (
            <TextSection
              customFields={this.props.customFields}
              test="test"
              section={this.props.section}
              editSection={this.props.editSection}
              updateUploadArray={this.updateUploadArray}
              onChange={(e)=>this.editSection({...this.props.section, defaultText:e })}
            />
          )}
        </CardContent>
        <Dialog
          open={this.state.editSectionDialogOpen}
          fullWidth
          maxWidth="lg"
          disableEnforceFocus={true}
        >
          {this.state.editSectionDialogOpen && (
            <AddSection
              isEdit
              section={
                typeof this.props.section === "string" ||
                this.props.section instanceof String
                  ? JSON.parse(this.props.section)
                  : this.props.section
              }
              addSection={this.editSection}
              close={this.openEdit}
            />
          )}
        </Dialog>
      </div>
    );
  }
  editSection = (section) => {
    this.props.editSection(section);
    this.setState({ editSectionDialogOpen: false });
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.section.css !== this.props.section.css) {
      this.setState({ css: JSON.parse(this.props.section.css) });
    }
  }
  componentDidMount() {
    if (this.props.section.css) {
      this.setState({ css: JSON.parse(this.props.section.css) });
    }
  }
  state = {
    firstNode: {},
    title: "",
    invisible: false,
    mouseOver: false,
    css: {},
    editSectionDialogOpen: false,
    attachmentIds:[],
  };
  openEdit = () => {
    this.setState({ editSectionDialogOpen: !this.state.editSectionDialogOpen });
  };
  deleteText = () => {};
  mouseOver = () => {
    this.setState({ mouseOver: !this.state.mouseOver });
  };
}
// export default connect(null, null)(DragSource('section', spec, collect)(TemplateSection));
export default connect(
  null,
  null
)(TemplateSection);
